








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'Input'
})
export default class Input extends Vue {
  @Prop() readonly label!: string
  @Prop({ default: false }) readonly required!: boolean
  @Prop({ default: false }) readonly disabled!: boolean
  @Prop({ default: 'text' }) readonly type!: string
  @Prop({ default: 'md' }) readonly size!: string
  @Prop({ default: '' }) readonly placeholder!: string
  @Prop({ default: '' }) readonly id!: string | number
  @Prop({ default: '' }) readonly name!: string
  @Prop({ default: '' }) readonly className!: string
	@Prop({ default: '' }) readonly iconClass!: string
	@Prop({ default: '' }) readonly default!: string
	@Prop({ default: '' }) readonly msgError!: string
	@Prop({ default: null }) readonly hasError!: boolean|null
	@Prop({ default: null }) readonly min!: number|string|null
	@Prop({ default: null }) readonly max!: number|string|null
  @Prop({ default: '', type: String }) readonly step!: string
  @Prop({ default: '', type: String }) readonly maxlength!: number
  @Prop({ default: false }) readonly append!: boolean

	value = this.default

  input () {
    this.$emit('input', this.type === 'number' ? Number(this.value) : this.value)
    this.$emit('change', this.type === 'number' ? Number(this.value) : this.value)
  }

  @Watch('default', { immediate: true, deep: true })
  changeOptions (newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.value = this.default
      this.input()
    }
  }
}
